
angular.module('app').directive('intlTelInput', function ($timeout) {
    return {
        restrict: 'E',
        template: `<input type="text" ng-model="ngModel" class="form-control" >`,
        require: 'ngModel',
        scope: {
            ngModel: '='
        },
        link: function (scope, element, attrs, ctrl) {

            scope.mascaraAtual = '';

            resolveCountry = (locale) => {
                if (locale.indexOf('_') !== -1) {
                    locale = locale.split('_')[1].toLowerCase();
                }

                return locale;
            }

            const options = {
                nationalMode: true,
                formatOnDisplay: true,
                utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.19/js/utils.min.js',
                preferredCountries: ['br', 'pt', 'cv'],
                initialCountry: resolveCountry($('html').attr('locale')),
                customPlaceholder: function (selectedCountryPlaceholder, selectedCountryData) {
                    $input.attr('data-phone-format', selectedCountryPlaceholder);
                    return attrs.placeholder ? attrs.placeholder : '';
                },
            };

            const $input = $(element).find('input');

            $input.intlTelInput(options);

            const iti = $input.data('plugin_intlTelInput');

            scope.$watch(function () {
                return $input.attr('data-phone-format')
            }, function (newValue) {
                scope.mascara = newValue.replace(/[0-9]/g, '0');
            })

            scope.$watch('ngModel', function (newValue, oldValue) {
                $input.val(newValue);
                $input.trigger('change');
            });

            scope.$watch('mascara', function () {
                mascarar();
            });

            scope.$watch(function () {
                return iti.getNumber();
            }, function (newValue) {
                mascarar();
            })

            scope.$watch(function () {
                return attrs.$attr['required'];
            }, function (newValue) {
                if (newValue) {
                    $input.attr('required', true);
                } else {
                    $input.removeAttr('required');
                }
            })


            scope.$watch(function () {
                return attrs.$attr['disabled'];
            }, function (newValue) {
                if (newValue) {
                    $input.attr('disabled', true);
                } else {
                    $input.removeAttr('disabled');
                }
            })

            $input.on('change', () => {
                iti.setNumber($input.val());
                if (iti.isValidNumber()) {
                    scope.ngModel = iti.getNumber();
                }
            });

            $input.on('blur', () => {

                if (!iti.isValidNumber()) {
                    $input.val('');
                    scope.ngModel = null;
                    scope.$apply();
                }
            });

            scope.timeoutCtrl = 0;

            const mascarar = () => {
                let mascaraEscolhida = '';

                const country = iti.getSelectedCountryData();

                if (country.dialCode === '55') {

                    if (iti.getNumber().length > 13) {
                        mascaraEscolhida = '(00) 00000-0000';
                    } else {
                        mascaraEscolhida = '(00) 0000-00009';
                    }
                } else {
                    mascaraEscolhida = scope.mascara;
                }

                if (scope.mascaraAtual !== mascaraEscolhida) {
                    scope.mascaraAtual = mascaraEscolhida;
                    $input.mask(mascaraEscolhida, {
                        clearIfNotMatch: false,
                    });
                }

            };

        }
    };
});